import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui";

type MatterDescriptionCellProps = {
  value?: string | null;
};

export function MatterDescriptionCell({ value }: MatterDescriptionCellProps) {
  const description = value?.trim();

  if (!description) return "-";

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="block max-w-full truncate" tabIndex={0}>
            {description}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-sm break-words whitespace-pre-wrap">
          {description}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
